import { pxToRem } from "src/styles/styleUtils";
import styled, { css } from "styled-components";

export const ButtonBase = css`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  appearance: none;
  background: none;
  border: none;
  border-radius: 0px;
  color: inherit;
  text-decoration: none;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
  outline: none;

  &:focus,
  :focus-within {
    outline: none;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  &:not(:disabled) {
    :focus-visible {
      outline: ${pxToRem(2)} solid ${({ theme }) => theme.blueAlt};
      outline-offset: ${pxToRem(1.25)};
    }
  }
`;

const Button = styled.button`
  ${ButtonBase}
  padding: ${pxToRem(6)} ${pxToRem(15)};
  background: ${({ theme }) => theme.blue};
  color: white;
  font-size: ${pxToRem(20)};
  font-family: ${({ theme }) => theme.fontSecondary};
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;

  &:not(:disabled) {
    :active,
    :focus-within,
    :focus-visible,
    :hover {
      /* optional: add more focus & hover styles here for UX */
    }
  }
`;

export const SecondaryButton = styled(Button)`
  background: ${({ theme }) => theme.grey_100};
  color: black;
`;

export default Button;

/*
Potential additions:
- OutlineButton
- GhostButton

Potential props:
- `size`: 'small' | 'large' | 'default'
to adjust font-size & padding, e.g.:

const getFontSize = (size: ButtonSize) => {
  switch (size) {
    case 'small':
      return '14px'
    case 'default':
      return '16px'
    case 'large':
      return '18px'
    default: {
      return '16px'
    }
  }
}

button {
  font-size: ${(props) => getFontSize(props.size)};
}
*/
